import { z } from 'zod';

const dateValueSchema = z.record(z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.number());

const AvailabilityResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.record(z.string().uuid(), dateValueSchema)
});

export { AvailabilityResponseSchema, dateValueSchema };

export type AvailabilityDateValue = z.infer<typeof dateValueSchema>;
export type AvailabilityResponse = z.infer<typeof AvailabilityResponseSchema>;